const api = {
  Login: '/auth/login',
  Logout: '/auth/logout',
  UserInfo: '/users/info'
}
export default api
